import React from 'react';
import {
    Table,
    Row,
    Spin,
    Col,
    Button,
    Popover,
    Popconfirm,
} from 'antd';
import { asyncGet, reStart, actions } from './reducers';
import { connect } from 'react-redux';
import SearchForm from './search.js';
import moment from 'moment';
import ResultShow from './ResultShow.js';
import { commendList } from '../../../utils/';
import SetOrder from './setOrder.js';

class AgencyAnalysis extends React.Component {
    state = {
        selectedRowKeys: [],
    };
    constructor(props) {
        super(props);
    }
    componentDidMount() {
        this.props.asyncGet();
    }

    changeHandle = (pagination, filters, sorter) => {
        this.props.changePagination(pagination);
        // this.props.changeSort({ key: sorter.field, order: sorter.order });
        this.props.asyncGet();
    };

    reStart = record => {
        this.props.reStart(record);
        this.props.asyncGet();
    }

    edit = record => {
        this.props.editShow();
        this.props.changeCurrentSelectId(record.clientId);
    }

    renderAction = (text, record) => {
        return (
            <div>
                <Popconfirm
                    title='确认重做'
                    okText='确定'
                    cancelText='取消'
                    onConfirm={() => {
                        this.reStart(record);
                    }}>
                    <Button type="danger" style={{ marginRight: '5px' }} size="small">
                        重做
                    </Button>
                </Popconfirm>
            </div>
        );
    };
    showResult = record => {
        this.props.resultShow();
        let {clientObjectIds} = record;
        let arr = Array.from(clientObjectIds);
        for(let i =0;i<arr.length;i++){
            arr[i].key = arr[i].clientId;
        }
        this.props.getTransferData({selectedRowKeys: clientObjectIds});
        this.props.getTransferDataCopy({selectedRowKeys1: clientObjectIds});
        this.props.getTransferDataCopy({selectedRowKeys3: clientObjectIds});
    }
    render() {
        let { list, uiStatus, pagination } = this.props;
        let { isLoading } = uiStatus;

        const columns = [
            {
                title: '命令id',
                dataIndex: 'commandId',
                key: 'commandId',
            },
            {
                title: '命令类型',
                dataIndex: 'action',
                key: 'action',
                render: text => {
                    if (text) {
                        let temp = commendList.filter(item => item.value == text);
                        if (temp && temp.length) {
                            return <span>{temp[0].name}</span>;
                        } else {
                            return '';
                        }
                    } else {
                        return '';
                    }
                },
            },
            {
                title: '命令内容',
                dataIndex: 'content',
                key: 'content',
            },
            {
                title: 'URL',
                dataIndex: 'url',
                key: 'url',
            },
            {
                title: '文件路径',
                dataIndex: 'path',
                key: 'path',
            },
            {
                title: '包名',
                dataIndex: 'packageName',
                key: 'packageName',
            },
            {
                title: '重试次数',
                dataIndex: 'retryTime',
                key: 'retryTime',
            },
            {
                title: '执行时间',
                dataIndex: 'timeStamp',
                key: 'timeStamp',
                render: text => {
                    return text ? moment(parseInt(text)).format('YYYY-MM-DD HH:mm:ss') : '';
                },
            },
            {
                title: '执行人',
                dataIndex: 'executor',
                key: 'executor',
            },
            {
                title: '目标客户端',
                dataIndex: 'clientObjectIds',
                key: 'clientObjectIds',
                render: (text, record) => {
                   /*const columns = [
                        {
                            title: '设备id',
                            dataIndex: 'clientId',
                            key: 'clientId',
                            render: (text, record) => {
                                return <span>{record.clientId}</span>;
                            },
                        },
                        {
                            title: 'success',
                            dataIndex: 'success',
                            key: 'success',
                        },
                        {
                            title: 'message',
                            dataIndex: 'msg',
                            key: 'msg',
                        }
                    ];
                    const content = (
                        <Table
                            columns={columns}
                            dataSource={text}
                            pagination={false}
                            scroll={{ y: 500 }}
                        />
                    );*/
                    return (
                       /*<Popover
                            content={content}
                            trigger="click">
                            <Button type="primary"> {text ? text.length : ''}</Button>
                        </Popover>*/

                        <Button type="primary" style={{ marginRight: '5px' }} size="small" onClick={() => {
                            this.showResult(record);
                        }}>{text ? text.length : ''}</Button>

                    );

                },
            },
            {
                title: '操作',
                dataIndex: 'operate',
                key: 'operate',
                render: (text, record, index) => {
                    return this.renderAction(text, record, index);
                },
            },
        ];

        return (
            <div style={{ marginBottom: '20px' }}>
                <Row style={{ marginTop: '10px', marginTop: '10px' }}>
                    <SearchForm {...this.props} />
                </Row>

                <Spin spinning={isLoading} tip="加载中...">
                    <Table
                        columns={columns}
                        dataSource={list}
                        pagination={{
                            ...pagination,
                        }}
                        defaultExpandAllRows={false}
                        onChange={this.changeHandle}
                    />
                   <ResultShow/>
                   <SetOrder />
                </Spin>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    list: state.commendList.list,
    pagination: state.commendList.pagination,
    proxyrepeatinfo: state.commendList.proxyrepeatinfo,
    uiStatus: state.commendList.uiStatus,
    agentsGroup: state.commendList.agentsGroup,
    transferData: state.commendList.transferData,
});
const mapDispatchToProps = dispatch => ({
    asyncGet: () => dispatch(asyncGet()),
    reStart: params => dispatch(reStart(params)),
    editShow: () => dispatch(actions.changeUiStatus({ isUpdateShow: true })),
    changeCurrentSelectId: id => dispatch(actions.changeCurrentSelectId(id)),
    getTransferData: data => dispatch(actions.getTransferData(data)),
    changePagination: data => dispatch(actions.changePagination(data)),
    resultShow: () => dispatch(actions.changeUiStatus({ resultShowStatus: true })),
    getTransferDataCopy: data => dispatch(actions.getTransferDataCopy(data)),
});
export default connect(mapStateToProps, mapDispatchToProps)(AgencyAnalysis);



// WEBPACK FOOTER //
// ./pages/client/commendList/index.js